import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Modal from '../components/Modal'
import { LoginForm } from './Login'
import { RegisterForm } from './Register'
import { useAuth } from '../contexts/AuthContext'

export default function Landing() {
	const [isRegisterOpen, setIsRegisterOpen] = useState(false)
	const [isLoginOpen, setIsLoginOpen] = useState(false)
	const navigate = useNavigate()
	const { startGuestSession } = useAuth()

	const handleTryMeOut = () => {
		startGuestSession()
		navigate('/dashboard')
	}

	return (
		<section className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 bg-animated-gradient">
			<div className="max-w-3xl mx-auto w-full animate-fade-in">
				<div className="glass-card px-6 sm:px-10 py-10 sm:py-14 text-center">
					<h1 className="text-5xl sm:text-6xl font-extrabold text-gradient-hero">
						DateShake
					</h1>
					<p className="mt-4 text-black text-lg sm:text-xl">
						Find better dates, faster. Curated matches, fun prompts, zero small talk.
					</p>
					<div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
						<button onClick={() => setIsRegisterOpen(true)} className="btn-primary w-40">Get Started</button>
						<button onClick={() => setIsLoginOpen(true)} className="btn-nav w-40 py-3">Sign In</button>
						<button onClick={handleTryMeOut} className="btn-secondary w-40 py-3 border-2 border-brand-orange text-brand-orange hover:bg-brand-orange hover:text-white transition-colors">
							Try Me Out
						</button>
					</div>
				</div>
			</div>
			<Modal isOpen={isRegisterOpen} onClose={() => setIsRegisterOpen(false)} title="Create your account">
				<RegisterForm onSuccess={() => setIsRegisterOpen(false)} />
			</Modal>
			<Modal isOpen={isLoginOpen} onClose={() => setIsLoginOpen(false)} title="Welcome back">
				<LoginForm onSuccess={() => setIsLoginOpen(false)} />
			</Modal>
		</section>
	)
}


